import { DATICONDUCENTE_VERBALE_DECURTAZIONE } from 'configuration/datiConducente'
import FormAnagrafica from 'components/form/FormAnagrafica'

const SERVIZIO_DATI_CONDUCENTE = 'datiConducente'

const STATO_DATI_CONDUCENTE_VERBALE = {
  MODULO_DA_COMPILARE: 'MODULO_DA_COMPILARE',
  MODULO_RICEVUTO: 'MODULO_RICEVUTO',
  MODULO_IN_ATTESA: 'MODULO_IN_ATTESA',
  MODULO_NON_DISPONIBILE: 'MODULO_NON_DISPONIBILE',
}

const SITUAZIONE_DATI_CONDUCENTE = {
  CASO_A: 'A',
  CASO_B: 'B',
  CASO_C: 'C',
}

const CFG = DATICONDUCENTE_VERBALE_DECURTAZIONE

const CFG_SITUAZIONI_DATI_CONDUCENTE = {
  [SITUAZIONE_DATI_CONDUCENTE.CASO_A]: {
    cfgNome: CFG.SITUAZIONE_CASO_A_NOME,
    cfgTitoloRiga1: CFG.SITUAZIONE_CASO_A_TITOLO_RIGA_1,
    cfgTitoloRiga2: CFG.SITUAZIONE_CASO_A_TITOLO_RIGA_2,
    cfgDescr: CFG.SITUAZIONE_CASO_A_DESCR,
    cfgDescrLunga: CFG.SITUAZIONE_CASO_A_DESCR_LUNGA,
    cfgDichiaraFrase1: CFG.INSERISCI_DATI_DICHIARA_CASO_A_FRASE_1,
    cfgDichiaraFrase2: CFG.INSERISCI_DATI_DICHIARA_CASO_A_FRASE_2,
  },
  [SITUAZIONE_DATI_CONDUCENTE.CASO_B]: {
    cfgNome: CFG.SITUAZIONE_CASO_B_NOME,
    cfgTitoloRiga1: CFG.SITUAZIONE_CASO_B_TITOLO_RIGA_1,
    cfgTitoloRiga2: CFG.SITUAZIONE_CASO_B_TITOLO_RIGA_2,
    cfgDescr: CFG.SITUAZIONE_CASO_B_DESCR,
    cfgDescrLunga: CFG.SITUAZIONE_CASO_B_DESCR_LUNGA,
    cfgDichiaraFrase1: CFG.INSERISCI_DATI_DICHIARA_CASO_B_FRASE_1,
    cfgDichiaraFrase2: CFG.INSERISCI_DATI_DICHIARA_CASO_B_FRASE_2,
  },
  [SITUAZIONE_DATI_CONDUCENTE.CASO_C]: {
    cfgNome: CFG.SITUAZIONE_CASO_C_NOME,
    cfgTitoloRiga1: CFG.SITUAZIONE_CASO_C_TITOLO_RIGA_1,
    cfgTitoloRiga2: CFG.SITUAZIONE_CASO_C_TITOLO_RIGA_2,
    cfgDescr: CFG.SITUAZIONE_CASO_C_DESCR,
    cfgDescrLunga: CFG.SITUAZIONE_CASO_C_DESCR_LUNGA,
    cfgDichiaraFrase1: CFG.INSERISCI_DATI_DICHIARA_CASO_C_FRASE_1,
    cfgDichiaraFrase2: CFG.INSERISCI_DATI_DICHIARA_CASO_C_FRASE_2,
  }
}

const MODALITA_INVIO_DATI_CONDUCENTE = {
  CARICA_ONLINE: 'upload',
  PEC: 'pec',
  RACCOMANDATA: 'rr',
  A_MANO: 'mano',
}

const CFG_MODALITA_INVIO_DATI_CONDUCENTE = {
  [MODALITA_INVIO_DATI_CONDUCENTE.CARICA_ONLINE]: {
    cfgTitolo: CFG.INVIO_MODULO_MODALITA_CARICA_ONLINE_TITOLO,
    cfgSottotitolo: CFG.INVIO_MODULO_MODALITA_CARICA_ONLINE_SOTTOTITOLO,
    cfgSpiegazione: CFG.CONSEGNA_MODULO_CARICA_ONLINE_SPIEGAZIONE,
  },
  [MODALITA_INVIO_DATI_CONDUCENTE.PEC]: {
    cfgTitolo: CFG.INVIO_MODULO_MODALITA_PEC_TITOLO,
    cfgSottotitolo: CFG.INVIO_MODULO_MODALITA_PEC_SOTTOTITOLO,
    cfgSpiegazione: CFG.CONSEGNA_MODULO_PEC_SPIEGAZIONE,
  },
  [MODALITA_INVIO_DATI_CONDUCENTE.RACCOMANDATA]: {
    cfgTitolo: CFG.INVIO_MODULO_MODALITA_RACCOMANDATA_TITOLO,
    cfgSottotitolo: CFG.INVIO_MODULO_MODALITA_RACCOMANDATA_SOTTOTITOLO,
    cfgSpiegazione: CFG.CONSEGNA_MODULO_RACCOMANDATA_SPIEGAZIONE,
  },
  [MODALITA_INVIO_DATI_CONDUCENTE.A_MANO]: {
    cfgTitolo: CFG.INVIO_MODULO_MODALITA_A_MANO_TITOLO,
    cfgSottotitolo: CFG.INVIO_MODULO_MODALITA_A_MANO_SOTTOTITOLO,
    cfgSpiegazione: CFG.CONSEGNA_MODULO_A_MANO_SPIEGAZIONE,
  },
}

function calcolaStatoDatiConducenteVerbale(verbale) {
  if (verbale) {
    const { stato_upload, richiesta_conducente } = verbale
    if (richiesta_conducente && (!stato_upload || stato_upload === 'respinto')) {
      return STATO_DATI_CONDUCENTE_VERBALE.MODULO_DA_COMPILARE
    }
    if (stato_upload === 'in_attesa') {
      return STATO_DATI_CONDUCENTE_VERBALE.MODULO_IN_ATTESA
    }
    if (stato_upload === 'accettato') {
      return STATO_DATI_CONDUCENTE_VERBALE.MODULO_RICEVUTO
    }
  }
  return STATO_DATI_CONDUCENTE_VERBALE.MODULO_NON_DISPONIBILE
}

function calcolaDichiaranteDatiConducente(situazione, anagrafica) {
  if (anagrafica.societa) return null
  return [SITUAZIONE_DATI_CONDUCENTE.CASO_A, SITUAZIONE_DATI_CONDUCENTE.CASO_B].includes(situazione) ? anagrafica : null
}

function trasformaDichiarazionePerSalvataggio(situazione, dichiarazione) {
  let dichiarante = dichiarazione.dichiarante
  let conducente = dichiarazione.conducente
  if ([SITUAZIONE_DATI_CONDUCENTE.CASO_A, SITUAZIONE_DATI_CONDUCENTE.CASO_C].includes(situazione)) {
    // dati anagrafici del dichiarante + patente del conducente
    const dichiaranteEConducente = { ...dichiarante, ...conducente }
    dichiarante = dichiaranteEConducente
    conducente = dichiaranteEConducente
  }
  return {
    ...dichiarazione,
    dichiarante: FormAnagrafica.trasformaValoriPerSalvataggio(dichiarante),
    conducente: FormAnagrafica.trasformaValoriPerSalvataggio(conducente),
    dichiarazioneTipo: situazione
  }

}

export {
  SERVIZIO_DATI_CONDUCENTE,
  STATO_DATI_CONDUCENTE_VERBALE,
  SITUAZIONE_DATI_CONDUCENTE,
  CFG_SITUAZIONI_DATI_CONDUCENTE,
  MODALITA_INVIO_DATI_CONDUCENTE,
  CFG_MODALITA_INVIO_DATI_CONDUCENTE,
  calcolaStatoDatiConducenteVerbale,
  calcolaDichiaranteDatiConducente,
  trasformaDichiarazionePerSalvataggio,
}